import React from "react"

import clsx from "clsx"

export type CardProps = React.ComponentPropsWithoutRef<`div`> & {
  header?: React.ReactNode
  footer?: React.ReactNode
  bodyClassName?: string
  headerClassName?: string
  footerClassName?: string
}

export const Card = React.forwardRef(function Card(
  {
    header,
    footer,
    children,
    className,
    bodyClassName,
    headerClassName,
    footerClassName,
    ...props
  }: CardProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  return (
    <div
      {...props}
      ref={ref}
      data-slot="card"
      className={clsx(
        `divide-y divide-border overflow-hidden rounded-lg bg-background shadow-sm`,
        className,
      )}
    >
      {header !== undefined && header !== null ? (
        <div
          data-slot="card-header"
          className={clsx(`px-4 py-5 sm:px-6`, headerClassName)}
        >
          {header}
        </div>
      ) : null}

      <div
        data-slot="card-body"
        className={clsx(`px-4 py-5 sm:p-6`, bodyClassName)}
      >
        {children}
      </div>

      {footer !== undefined && footer !== null ? (
        <div
          data-slot="card-footer"
          className={clsx(`px-4 py-4 sm:px-6`, footerClassName)}
        >
          {footer}
        </div>
      ) : null}
    </div>
  )
})
